import {TreatmentTarget} from './treatment_target'
export class IVRMenuTreatment extends TreatmentTarget {
  constructor() {
    super();
  }
  
  addOption() {
    let optionsContainer = this.querySelector(".ivr_menu_options");
    let optionVal = optionsContainer.children[optionsContainer.children.length -1 ].getDTMFInput();
    if(optionVal == null) {
      optionVal = 1;
    } else {
      optionVal += 1;
    }

    let option = document.createElement("ivr-menu-option");
    let optionFlow = document.createElement("treatment-flow");
    optionFlow.flowChanged = this.childChangeOccured;
    optionFlow.appendChild(document.createElement("treatment-element"))
    
    optionsContainer.appendChild(option);
    this.appendChild(optionFlow);
    option.setDTMFInput(optionVal);
    this.selectOption(option);
  }

  selectOption(option) {
    let optionsContainer = this.querySelector(".ivr_menu_options");
    optionsContainer.children.forEach((item, index) => {item.setSelected(false)});
    this.querySelector("ivr-default").setSelected(false);
    this.querySelectorAll(':scope > treatment-flow').forEach((item, index) => {item.style.cssText = 'display: none;'})

    option.setSelected(true);

    if(option.tagName == "IVR-DEFAULT") {
      this.querySelector(".ivr_entry").innerHTML = "Default"
      this.querySelector(':scope > treatment-flow.default-flow').style.cssText = 'display:block;';
    } else {
      this.querySelector(".ivr_entry").innerHTML = option.getDTMFInput()
      this.querySelectorAll(':scope > treatment-flow:not(.default-flow)')[Array.prototype.indexOf.call(optionsContainer.children, option)].style.cssText = 'display:block;';
    }
  }

  removeOption(option) {
    let optionsContainer = this.querySelector(".ivr_menu_options");
    this.querySelectorAll(':scope > treatment-flow:not(.default-flow)')[Array.prototype.indexOf.call(optionsContainer.children, option)].remove();
    let selectFirstOption = !option.hidden;
    option.remove();

    if(selectFirstOption) this.selectOption(optionsContainer.children[0])

  }

  childChangeOccured(flow, newElement) {
    if(Array.prototype.indexOf.call(flow.children, newElement) == 0) {
      let indexOfFlow = Array.prototype.indexOf.call(this.closest('ivr-menu-treatment').querySelectorAll(':scope > treatment-flow:not(.default-flow)'), flow);
      let option = this.closest('ivr-menu-treatment').querySelectorAll(':scope > .ct_ivr_action ivr-menu-option')[indexOfFlow];
      option.querySelector("div.type i").className = `fa ${newElement.getIcon()}`
    }   
  }

  getIcon() {
    return 'fa-th'
  }

  static getType() {
    return "IVR"
  }

  getData() {
    let target = { 
        target_name: null,
        target_type: "IVR", 
        ring_to_number: null,
        ivr_target_audio_id: null,
        ivr_choice_timeout: null,
        children: [],
        actions: []
      }
    let audio_id = this.querySelector(":scope > .ct_ivr_action select.audio_id").value;
    target.target_name = `Play IVR ${audio_id}`;
    target.ivr_target_audio_id = audio_id;
    target.ivr_choice_timeout = 5

    this.querySelectorAll(":scope > .ct_ivr_action ivr-menu-option").forEach(function(option, index) {
      let ivr_child = option.getData();
      this.querySelectorAll(":scope > treatment-flow:not(.default-flow)")[index].getData(ivr_child);
      target.children.push(ivr_child);
    }.bind(this));

    let default_flow = this.querySelector(":scope > treatment-flow.default-flow");
    if(default_flow.hasData()) {
      let default_ivr_child = this.querySelector(":scope > .ct_ivr_action ivr-default").getData();
      default_flow.getData(default_ivr_child);
      target.children.push(default_ivr_child);
    }

    return target
  }

  validate() {
    let response = {requiredMissing: false, errorMessages: []};

    this.querySelectorAll(':scope > .ct_ivr_action input, :scope > .ct_ivr_action select').forEach((input) => { 
      input.classList.remove("error")
      if(input.value === "" || input.value === "null") {
        input.classList.add("error")
        response.requiredMissing = true 
      }
    });

    this.querySelectorAll(':scope > treatment-flow:not(.default-flow)').forEach(function(flow, index) {
      let flow_validation = flow.validate();
      if(flow_validation.requiredMissing) {
        response.requiredMissing = true;
      }
      Array.prototype.push.apply(response.errorMessages, flow_validation.errorMessages);

      flow.closest('ivr-menu-treatment').querySelectorAll(':scope > .ct_ivr_action ivr-menu-option')[index].classList.remove("error");
      if(flow_validation.requiredMissing || (flow_validation.errorMessages != null && flow_validation.errorMessages.length > 0) ) {
        flow.closest('ivr-menu-treatment').querySelectorAll(':scope > .ct_ivr_action ivr-menu-option')[index].classList.add("error");
      }
    }); 

    let default_flow = this.querySelector(':scope > treatment-flow.default-flow');
    let default_flow_validation = default_flow.validate(false);

    if(default_flow_validation.requiredMissing) {
      response.requiredMissing = true;
    }
    Array.prototype.push.apply(response.errorMessages, default_flow_validation.errorMessages);

    default_flow.closest('ivr-menu-treatment').querySelector(':scope > .ct_ivr_action ivr-default').classList.remove("error");
    if(default_flow_validation.requiredMissing || (default_flow_validation.errorMessages != null && default_flow_validation.errorMessages.length > 0) ) {
      default_flow.closest('ivr-menu-treatment').querySelector(':scope > .ct_ivr_action ivr-default').classList.add("error");
    }

    let first_error = this.querySelector(":scope > .ct_ivr_action ivr-menu-option.error");
    if(first_error != null) {
      this.selectOption(first_error);
    }
    return response;
  }

  connectedCallback() {
    this.innerHTML = 
      `<div class="col-sm-12 ct_action ct_ivr_action" data-action_type=IVR>
        <div class="panel panel-default">
          <h4>Call Menu</h4><a class="remove"><i class="fa fa-times" aria-hidden="true"></i></a>
          <div class="form-group">
            <div class="row">
              <div class="col-md-9">
                <label>Menu Audio</label>
                <div class="row">
                  <div class="col-md-12">
                    <select is=audio-select class="form-control audio_id" data-selected="${this.target != null ? this.target.ivr_target_audio_id : 'null'}" data-selected-name="${this.target != null && this.target.target_audio !=null ? this.target.target_audio.audio_desc : 'null'}"  target_audio_type=1></select>
                    <div class="manage_audio">
                    <a class="btn btn-primary ct_manage_audio" data-audio-type-id="1" style="width:100%;">Manage</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-md-3">
                  <label for="exampleInputPassword1">Menu Input</label>
              </div>
              <div class="col-md-4">
                  <label for="exampleInputPassword1">Description</label>
              </div>
            </div>
            <div class="ivr_menu_options">
            </div>
            <ivr-default></ivr-default>
          </div>
        </div>
      </div>
      <div class="option_path">
        <div class="col-sm-12 ct_line">
          <div class="bottom_line"></div>
          <div class="ct_vertical_arrow"></div>
          <div class="option_text">Caller Pressed <span class="ivr_entry">TODO</span></div>
          <div class="ct_vertical_arrow">
            <div class=arrow-down></div>
          </div>
        </div>
      </div> 
    `;

    let defaultFlow = document.createElement("treatment-flow");
    defaultFlow.classList.add("default-flow");
    defaultFlow.flowChanged = this.childChangeOccured;
    defaultFlow.appendChild(document.createElement("treatment-element"))
    this.appendChild(defaultFlow);

    let optionsContainer = this.querySelector(".ivr_menu_options")
    if(this.target == null) {

      let option = document.createElement("ivr-menu-option");
      let optionFlow = document.createElement("treatment-flow");
      optionFlow.flowChanged = this.childChangeOccured;
      optionFlow.appendChild(document.createElement("treatment-element"))

      
      
      optionsContainer.appendChild(option);
      this.appendChild(optionFlow);

      this.selectOption(option);
    } else {
      this.target.children.forEach(function(child, index) {
        if(child.ivr_option == null) {
          this.querySelector(":scope > treatment-flow.default-flow").innerHTML = "";
          this.querySelector(":scope > treatment-flow.default-flow").renderFlow(child);
        } else {
          let option = document.createElement("ivr-menu-option");
          let optionFlow = document.createElement("treatment-flow");
          option.target_child = child;
          optionFlow.renderFlow(child);

          optionsContainer.appendChild(option);
          this.appendChild(optionFlow);
        }
      }.bind(this));
      this.selectOption(this.querySelectorAll(":scope > .ct_ivr_action ivr-menu-option")[0]);
    }
    super.connectedCallback();
  }
}

customElements.define('ivr-menu-treatment', IVRMenuTreatment);

class IVRMenuOption extends HTMLElement {
  constructor() {
    super();
  }

  setSelected(is_selected) {
    this.selected = is_selected
    if(is_selected) {
      this.classList.add("selected");
    }
    else {
      this.classList.remove("selected");
    }
  }

  getDTMFInput() {
    return Number(this.querySelector(".ivr_option_input").value);
  }

  setDTMFInput(dtmf_input) {
    this.querySelector(".ivr_option_input").value = dtmf_input;
  }

  getData() {
    return {
      ivr_option: this.querySelector(".ivr_option_input").value, 
      description: this.querySelector(".ivr_option_desc").value,
      destination: null,
      actions: []
    };
  }

  connectedCallback() {
    this.innerHTML = `<div class="row" style="margin-bottom:5px; position:relative;">
          <div class="col-md-3">
            <input is="ivr-option-input" maxlength=10 class="form-control ivr_option_input" value="${this.target_child != null ? this.target_child.ivr_option : "1"}" placeholder="1-9, * or #">
          </div>
          <div class="col-md-4">
              <input type="text" class="form-control header_value ivr_option_desc" placeholder="Description of action" value="${this.target_child != null && this.target_child.description != null ? this.target_child.description : "for Sales"}" />
          </div>
          <div class="col-md-3" style="line-height:30px;">
            <a class="remove_ivr_menu_option"><span class="fa fa-minus"></span></a>
            <a class="add_ivr_menu_option"><span class="fa fa-plus"></span></a>
          </div>
          <div class="col-md-1 pull-right type">
            <i style="font-size: 30px; color: #999" class="fa " aria-hidden="true"></i>
          </div>
          <div class="ct_arrow"></div>
        </div>`

    this.querySelector(".remove_ivr_menu_option").addEventListener('click', function(event) {
        event.preventDefault();
        let parent = this.closest("ivr-menu-treatment");
        parent.removeOption(this);
      }.bind(this));
    this.querySelector(".add_ivr_menu_option").addEventListener('click', function(event) {
        event.preventDefault();
        this.closest("ivr-menu-treatment").addOption();
      }.bind(this));
    this.addEventListener('click', function(event) {
      if(event.target.tagName != "SPAN" && event.target.tagName != "A") {
        this.closest("ivr-menu-treatment").selectOption(this);
      }
    }.bind(this));
    this.querySelector('.ivr_option_input').addEventListener('change', function(event) {
      this.closest("ivr-menu-treatment").selectOption(this);
    }.bind(this));
  }
}

customElements.define('ivr-menu-option', IVRMenuOption);

class IVROptionInput extends HTMLInputElement {
  constructor() {
    super();
    
    this.addEventListener('keyup', () => {
      this.value = this.value.replace(/[^#*0-9]/g, '');
      console.log(this.value);
    });
    this.type="text";
    this.maxlength = 10;
  }
};

customElements.define('ivr-option-input', IVROptionInput, {
  extends: 'input',
});

class IVRDefault extends HTMLElement {
  constructor() {
    super();
  }

  setSelected(is_selected) {
    this.selected = is_selected
    if(is_selected) {
      this.classList.add("selected");
    }
    else {
      this.classList.remove("selected");
    }
  }

  getData() {
    return {
      ivr_option: null, 
      description: "Default",
      destination: null,
      actions: []
    };
  }

  setOptionLabel(num) {
    this.querySelector(".title h5").innerHTML = `Schedule ${num}`
  }

  connectedCallback() {
    this.innerHTML = `
        <style>
          
        </style>
        <div class="row no-gutters" style="margin-bottom:5px; position:relative;">
          
          <div class="row">
              <div class="col-md-12 title">  
                <h5>Default Option</h5>
                <p>Set a default treatment for when user does not enter an input.</p>
              </div>
          </div>


          <div class="ct_arrow"></div>
        </div>`

    this.addEventListener('click', function(event) {
      this.closest("ivr-menu-treatment").selectOption(this);
    }.bind(this));
  }
}

customElements.define('ivr-default', IVRDefault);